// Vendor imports
const _ = require('lodash')
const { createSelector } = require('reselect')
// Client V2 common imports
const { formatBytes } = require('client-v2/common/containers/upload-image-modal/utils')

const containerState = state => state.collectionEditHeaderImageModal

const isVisible = createSelector(
  containerState,
  Boolean
)

const file = createSelector(
  containerState,
  s => {
    const file = _.get(s, 'droppedFile')
    if (typeof File === 'function' && file instanceof File) {
      return file
    }
  }
)

const savedImageUrl = createSelector(
  containerState,
  s => _.get(s, 'savedImageUrl', null)
)

const tips = createSelector(
  reqs => reqs,
  reqs => {
    const supportedFormats = reqs.supportedFormats.join(', ')
    const resizeDimensions = `${reqs.resizeWidth}×${reqs.resizeHeight} pixels`
    const minDimensions = `${reqs.minWidth}×${reqs.minHeight} pixels`
    const maxFileSize = formatBytes(reqs.maxFileSize, 0)
    return [
      `We support these image formats: ${supportedFormats}`,
      `The image will be resized to fit within ${resizeDimensions}.`,
      `Minimum image size is ${minDimensions}.`,
      `Maximum file size is ${maxFileSize}.`
    ]
  }
)

module.exports = {
  file,
  isVisible,
  savedImageUrl,
  tips
}
